<template>
    <span
        class="sbs-base-counter"
        :class="counterClasses"
        :style="counterStyles">
        {{ value }}
    </span>
</template>

<script>
import themesMixin from '../../mixins/themes.js';

/**
 * Базовый компонент счётчика
 */
export default {
    name: 'SbsBaseCounter',
    mixins: [themesMixin],
    computed: {
        counterStyles() {
            return {
                backgroundColor: this.counterBackgroundColor,
            };
        },
        counterBackgroundColor() {
            let color = '';

            if (this.backgroundColor && !this.theme) {
                color = this.backgroundColor;
            }

            return color;
        },
        counterClasses() {
            return [...this.themeClasses];
        },
    },
    props: {
        /**
         * Цвет фона счётчика
         */
        backgroundColor: {
            type: String,
            default: '',
        },
        /**
         * Значение счётчика
         */
        value: {
            type: [Number, String],
            default: null,
        },
    },
};
</script>

<style lang="scss">
$counter-size: 24px;

.sbs-base-counter {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: $counter-size;
    height: $counter-size;
    padding: 2px 3px;
    border-radius: $rounded-pill;

    @include typo-subtext-demi;
}
</style>
